import React from 'react';
import { Link } from 'react-router-dom';

/**
 * ToolsTable Component
 * 
 * Exactly matches the legacy site's tool table structure
 */
const ToolsTable = ({ 
  tools, 
  categorySlug, 
  subcategorySlug 
}) => {
  if (!tools || tools.length === 0) return null;
  
  return (
    <table id="tool-table">
      <colgroup className="tool-table-columns">
        <col className="tool-table-columns-20" />
        <col className="tool-table-columns-60" />
        <col className="tool-table-columns-20" />
      </colgroup>
      
      <tbody>
        <tr className="table-section-tools">
          <td>Tool</td>
          <td>Description</td>
          <td>Template</td>
        </tr>
        
        {tools.map(tool => (
          <tr key={tool.slug}>
            <td>
              <Link to={`/${categorySlug}/${subcategorySlug}/#${tool.slug}`} className="link-table">
                {tool.title}
              </Link>
            </td>
            <td>{tool.description}</td>
            <td>
              {tool.resources && tool.resources.length > 0 ? (
                <>
                  {tool.resources.some(r => r.type === 'pdf') && (
                    <>
                      <i className="far fa-file-pdf">&nbsp;&nbsp;</i>
                      <a 
                        href={tool.resources.find(r => r.type === 'pdf')?.href} 
                        className="link-table"
                      >
                        PDF
                      </a>
                      {tool.resources.some(r => r.type === 'miro') && (
                        <>&nbsp;&nbsp;</>
                      )}
                    </>
                  )}
                  
                  {tool.resources.some(r => r.type === 'miro') && (
                    <>
                      <i className="fas fa-chalkboard"></i>&nbsp;&nbsp;
                      <a 
                        href={tool.resources.find(r => r.type === 'miro')?.href} 
                        className="link-table"
                      >
                        Miro
                      </a>
                    </>
                  )}
                </>
              ) : (
                'Multiple'
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ToolsTable; 